export default "__VITE_ASSET__BnGsdJmU__"